import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class DoganeService {
  constructor(http, eventBus){
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_pratiche.url}` 
    this.apiUrl = `${services.ask_api.url}/management`
    this.filemanager = new FileManager()
  }

  async statusmese(mese, anno = null) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/statusmese/${mese}${anno ? `/${anno}` : ''}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il controllo dello stato del mese:', error)
      throw error
    }
  }

  async existsRata(mese, anno = null) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/existsRata/${mese}${anno ? `/${anno}` : ''}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il controllo dell\'esistenza di una rata:', error)
      throw error
    }
  }

  async existsFat(mese, anno = null) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/existsFat/${mese}${anno ? `/${anno}` : ''}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il controllo dell\'esistenza di una fattura:', error)
      throw error
    }
  }

  async updateDoganaProvincia(data) {
    try {
      const response = await this.http.post(`${this.apiUrl}/AreaDogane/updateDoganaProvincia`, data)
      return response.data
    } catch (error) {
      console.error('Errore durante l\'aggiornamento della dogana per una provincia:', error)
      throw error
    }
  }

  async updateRataProvincia(data) {
    try {
      const response = await this.http.post(`${this.apiUrl}/AreaDogane/updateRataProvincia`, data)
      return response.data
    } catch (error) {
      console.error('Errore durante l\'aggiornamento della rata per una provincia:', error)
      throw error
    }
  }

  async getListPodRange(d1, d2 = null, prov = null) {
    try {
      const params = { d1, d2, prov }
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getListPodRange`, { params })
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero della lista dei P.O.D.:', error)
      throw error
    }
  }

  async getListPdrRange(d1, d2 = null, prov = null) {
    try {
      const params = { d1, d2, prov }
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getListPdrRange`, { params })
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero della lista dei P.D.R.:', error)
      throw error
    }
  }

  async getRcuPodsInRange(from, to, province) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getRcuPodsInRange/${from}/${to}/${province}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il conteggio dei P.O.D. in un intervallo di date:', error)
      throw error
    }
  }

  async getRcuPdrsInRange(from, to, province) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getRcuPdrsInRange/${from}/${to}/${province}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il conteggio dei P.D.R. in un intervallo di date:', error)
      throw error
    }
  }

  async calcolaAccise(pod) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/calcolaAccise/${pod}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il calcolo delle accise:', error)
      throw error
    }
  }

  async getStatuti() {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getStatuti`)
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero degli statuti:', error)
      throw error
    }
  }

  async getStatutiElettrico(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getStatutiElettrico`, {
        params: params,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero degli statuti con dati:", error);
      throw error;
    }
  }

  async getStatutiGas(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getStatutiGas`, {
        params: params,
      });
      return response.data;
    } catch (error) {
      console.error("Errore durante il recupero degli statuti con dati:", error);
      throw error;
    }
  }


  async getDataByProvince(province) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getDataByProvince/${province}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero dei dati per provincia:', error)
      throw error
    }
  }

  async getMonthlyData(province, month, year) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/getMonthlyData/${province}/${month}/${year}`)
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero dei dati mensili:', error)
      throw error
    }
  }

  async exportFornitureElettriche(params) {
    try {
      const response = await this.http.post(
        `${this.apiUrl}/AreaDogane/export-forniture-elettriche`, 
        params,
        { responseType: 'blob' }
      );
      return response.data;
    } catch (error) {
      console.error('Errore durante l\'esportazione delle forniture elettriche:', error);
      throw error;
    }
  }

  async getListaPod(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/get-lista-pod`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero della lista POD:', error);
      throw error;
    }
  }

  async getDoganeMensiliEE(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/dogane-mensili-ee`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati mensili EE:', error);
      throw error;
    }
  }

  async getDoganeMensiliGas(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/dogane-mensili-gas`, {
        params
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante il recupero dei dati mensili GAS:', error);
      throw error;
    }
  }

  async exportFornitureGas(params) {
    try {
      const response = await this.http.post(`${this.apiUrl}/AreaDogane/export-forniture-gas`, params, {
        responseType: 'blob'
      });
      return response.data;
    } catch (error) {
      console.error('Errore durante l\'export delle forniture GAS:', error);
      throw error;
    }
  }

  async getDichiarazioneAnnualeEE(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/dichiarazione-annuale-ee`, {
        params,
        responseType: params.download ? 'blob' : 'json',
        timeout: 30000
      });
      return params.download ? response.data : response.data;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        console.error('Timeout della richiesta:', error);
        throw new Error('La richiesta ha impiegato troppo tempo. Riprova.');
      }
      console.error('Errore durante il recupero della dichiarazione annuale EE:', error);
      throw error;
    }
  }

  async getDichiarazioneAnnualeGas(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/dichiarazione-annuale-gas`, {
        params,
        responseType: params.download ? 'blob' : 'json',
        timeout: 30000
      });
      return params.download ? response.data : response.data;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        console.error('Timeout della richiesta:', error);
        throw new Error('La richiesta ha impiegato troppo tempo. Riprova.');
      }
      console.error('Errore durante il recupero della dichiarazione annuale GAS:', error);
      throw error;
    }
  }

  async getDichiarazioneAnnualeAddizionali(params) {
    try {
      const response = await this.http.get(`${this.apiUrl}/AreaDogane/dichiarazione-annuale-addizionali`, {
        params,
        timeout: 30000
      });
      return response.data;
    } catch (error) {
      if (error.code === 'ECONNABORTED') {
        console.error('Timeout della richiesta:', error);
        throw new Error('La richiesta ha impiegato troppo tempo. Riprova.');
      }
      console.error('Errore durante il recupero della dichiarazione annuale addizionali GAS:', error);
      throw error;
    }
  }

  async getDichiarazioneXml(periodo, tipo, params) {
    try {
      const response = await this.http.get(
        `${this.apiUrl}/AreaDogane/dichiarazione-${periodo}-${tipo}-xml`,
        {
          params,
          responseType: 'blob'
        }
      );
      return response.data;
    } catch (error) {
      console.error(
        `Errore durante il recupero del file XML della dichiarazione ${periodo} ${tipo.toUpperCase()}:`,
        error
      );
      throw error;
    }
  }

  async getInviiTelematici(params = {}) {
    try {
      const response = await this.http.get(
        `${this.apiUrl}/AreaDogane/invii-telematici`,
        { params }
      )
      return response.data
    } catch (error) {
      console.error('Errore durante il recupero dello storico degli invii telematici:', error)
      throw error
    }
  }

  async getDisponibilitaInviiTelematici() {
    const response = await this.http.get(`${this.apiUrl}/AreaDogane/invii-telematici/disponibilita`)
    return response.data
  }

  async creaInvioTelematico(data) {
    const response = await this.http.post(`${this.apiUrl}/AreaDogane/invii-telematici`, data, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    return response.data
  }

  async downloadXmlInvioTelematico(id) {
    const response = await this.http.get(`${this.apiUrl}/AreaDogane/invii-telematici/${id}/xml`, {
      responseType: 'blob'
    })
    return response.data
  }

}
